import React from 'react'
import { Navigate } from 'react-router-dom'

// Nothing lives at /Carriership any more; carriers start on their zones.
function Carriership() {
  return <Navigate to="/create-zone" replace />
}

export default Carriership
